import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, observable } from 'rxjs';
import { PlugAndPlayDragModel, PlugAndPlayModel } from '../models/plugAndPlay.model';
import { InfraService } from './infra.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class CustomizedLayoutService {

    private configUrl: string;
    private apiCoreUrl: string;
    private apiCoreUrlUS: string;
    private apiCoreUrlEMEIA: string;
    private apiCoreUrlAPAC: string;
    private url:string;

   
        
    constructor(private infraService: InfraService, private http: HttpClient) {
        this.infraService.infraDetails$.subscribe(data => {
            this.configUrl = data.WebEndPoint1 + 'CustomizedLayout';
            this.apiCoreUrl = data.WebEndPoint2 + 'CustomizedLayout/';
        });

        if (environment.env === 'uat') {
            this.url = 'assets/infraendpoints/infraenpointsUAT.json';
        }
        else if (environment.env === 'prod') {
            this.url = 'assets/infraendpoints/infraenpointsProd.json';
        }

        this.getUrls().subscribe(response =>{
            this.apiCoreUrlUS = response[0].WebEndPoint1 + 'CustomizedLayout/';
            this.apiCoreUrlEMEIA = response[0].WebEndPoint2 + 'CustomizedLayout/';
            this.apiCoreUrlAPAC = response[0].WebEndPoint3 + 'CustomizedLayout/';

            console.log(this.apiCoreUrlUS,'us');
            console.log(this.apiCoreUrlEMEIA,'emeia');
            console.log(this.apiCoreUrlAPAC,'apac');

        });
    }


    private getUrls(): Observable<any> {
        return this.http.get<any>(this.url);
    }

    
    public getCustomizedLayoutByUserId(userId: number, templateId: number, layoutName : string | null, languageId: number): Observable<any> {       

        return this.http.get<any>(`${this.apiCoreUrl}GetCustomizedLayout/${userId}/${templateId}/${layoutName}/${languageId}`);
    }

    public GetBalanceSheetGroupForUserLayout(languageId : number, layoutName :string | null): Observable<string[]> {  
        return this.http.get<string[]>(`${this.apiCoreUrl}GetBalanceSheetGroupForUserLayout/${languageId}/${layoutName}`);
    }

    public GetLayoutNames(userId:number): Observable<any[]> {  
        return this.http.get<any[]>(`${this.apiCoreUrl}GetLayoutNames/${userId}`);
    }

    public saveAllData(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number, isSaveAsclicked:boolean,selectedLanguageId : number , selectedCustomTemplate : string , users?:any) {
        return this.http.post(`${this.apiCoreUrl}SaveUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId ,'selectedCustomTemplate': selectedCustomTemplate,'Users':users});
    }

    public ShareData(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number, isSaveAsclicked:boolean,selectedLanguageId : number , selectedCustomTemplate : string , users?:any , isSendEmail?:boolean ) {
        return this.http.post(`${this.apiCoreUrl}ShareUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId ,'selectedCustomTemplate': selectedCustomTemplate,'Users':users,'IsSendEmail':isSendEmail});
    }

    public saveAllDataUS(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number, isSaveAsclicked:boolean,selectedLanguageId : number, selectedCustomTemplate : string , users?:any) {
        return this.http.post(`${this.apiCoreUrlUS}SaveUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId,'selectedCustomTemplate': selectedCustomTemplate,'Users':users});
    }

    public saveAllDataEMEIA(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number, isSaveAsclicked:boolean,selectedLanguageId : number,selectedCustomTemplate : string,users?:any) {
        return this.http.post(`${this.apiCoreUrlEMEIA}SaveUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId,'selectedCustomTemplate': selectedCustomTemplate ,'Users':users});
    }

    public saveAllDataAPAC(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number , isSaveAsclicked:boolean, selectedLanguageId : number,selectedCustomTemplate : string,users?:any) {
        return this.http.post(`${this.apiCoreUrlAPAC}SaveUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId,'selectedCustomTemplate': selectedCustomTemplate , 'Users' : users});
    }


    public ShareLayoutUS(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number, isSaveAsclicked:boolean,selectedLanguageId : number, selectedCustomTemplate : string , users?:any,isSendEmail?:boolean) {
        return this.http.post(`${this.apiCoreUrlUS}ShareUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId,'selectedCustomTemplate': selectedCustomTemplate,'Users':users,'IsSendEmail':isSendEmail});
    }

    public ShareLayoutEMEIA(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number, isSaveAsclicked:boolean,selectedLanguageId : number,selectedCustomTemplate : string,users?:any,isSendEmail?:boolean) {
        return this.http.post(`${this.apiCoreUrlEMEIA}ShareUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId,'selectedCustomTemplate': selectedCustomTemplate ,'Users':users,'IsSendEmail':isSendEmail});
    }

    public ShareLayoutAPAC(plugAndPlayData: PlugAndPlayModel[], smIds: number[], regionId: number, layoutName: string, templateId: number , isSaveAsclicked:boolean, selectedLanguageId : number,selectedCustomTemplate : string,users?:any, isSendEmail?:boolean) {
        return this.http.post(`${this.apiCoreUrlAPAC}ShareUserLayoutDetails`, { 'CustomizedLayoutData': plugAndPlayData, 'SMIds': smIds, 'RegionId': regionId, 'LayoutName': layoutName, 'TemplateId': templateId , 'IsSaveclicked':isSaveAsclicked ,'LanguageId' : selectedLanguageId,'selectedCustomTemplate': selectedCustomTemplate , 'Users' : users , 'IsSendEmail':isSendEmail});
    }

    public deleteCustomizedLayout(userId, templateId: number, layoutName) {
        return this.http.post(`${this.apiCoreUrl}DeleteCustomizedLayout/${userId}/${templateId}/${layoutName}`, {});
    }

    public deleteCustomizedLayoutUS(userId, templateId: number, layoutName) {
        return this.http.post(`${this.apiCoreUrlUS}DeleteCustomizedLayout/${userId}/${templateId}/${layoutName}`, {});
    }
    public deleteCustomizedLayoutEMEIA(userId, templateId: number, layoutName) {
        return this.http.post(`${this.apiCoreUrlEMEIA}DeleteCustomizedLayout/${userId}/${templateId}/${layoutName}`, {});
    }
    public deleteCustomizedLayoutAPAC(userId, templateId: number, layoutName) {
        return this.http.post(`${this.apiCoreUrlAPAC}DeleteCustomizedLayout/${userId}/${templateId}/${layoutName}`, {});
    }

}
